import { useMemo } from 'react'
import * as Yup from 'yup'

import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'

export const useAddLogoValidationSchema = () => {
  const {
    embroidery: {
      modal: { forms: fixtures },
    },
  } = useTranslation()

  const validationSchema = useMemo(() => {
    return Yup.object().shape({
      __type: Yup.mixed().oneOf(['AddLogoFormValues']),
      logoFileId: Yup.string().required(fixtures.validationErrorMessages.requiredLogo),
      logoPlacement: Yup.object()
        .shape({})
        .required(fixtures.validationErrorMessages.requiredLogoPlacement),
    })
  }, [fixtures])

  return validationSchema
}
